import { useEffect, useState } from 'react';
import { getArtistData } from '../ArtistWidget/api';
import { Artist, ArtistResponse } from '../ArtistWidget/types';

export const useFetchArtists = (eventId: string, artistList: Artist[]) => {
    const [artists, setArtistsData] = useState<ArtistResponse[] | null>([]);

    useEffect(() => {
        const fetchArtists = async () => {
            try {
                const response = await getArtistData(eventId, artistList);
                setArtistsData(response);
            } catch (err) {
                console.error('Failed to fetch artist data:', err);
                setArtistsData(null); // Set artists to null on error
            }
        };
        fetchArtists();
    }, [eventId, artistList]);

    return artists;
};
